// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3f5006cd","977":"cf70748b"}[chunkId] + ".chunk.js";
};